import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = {
    url: String,
    title: String,
    text: String
  }

  async share() {
    const url = new URL(this.urlValue, window.location.origin).toString()
    const payload = { title: this.titleValue, text: this.textValue, url }

    if (navigator.share) {
      try {
        await navigator.share(payload)
        this.showStatus("Shared")
        this.trackCompletion("native")
        return
      } catch (error) {
        if (error.name === "AbortError") return
      }
    }

    try {
      await navigator.clipboard.writeText(url)
      this.showStatus("Link copied")
      this.trackCompletion("clipboard")
    } catch (_error) {
      this.showStatus("Copy the address from your browser")
    }
  }

  showStatus(message) {
    this.statusTarget.textContent = message
    window.clearTimeout(this.statusTimer)
    this.statusTimer = window.setTimeout(() => {
      this.statusTarget.textContent = ""
    }, 3000)
  }

  trackCompletion(method) {
    this.element.dispatchEvent(new CustomEvent("vaibe:analytics", {
      bubbles: true,
      detail: {
        event: "report_share_completed",
        properties: { method }
      }
    }))
  }
}
